import {useSearchParams} from 'react-router-dom';

export const useIsOpenWebView = () => {
  const [searchParams] = useSearchParams();
  const openWebViewSearchParam = searchParams.get('isopenwebview') ?? 'false';
  const isOpenWebView = openWebViewSearchParam === 'true';

  return isOpenWebView;
};
